
import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
export default async function isUserActive() {
    const username = localStorage.getItem("user");
    const secureKey = localStorage.getItem('secureKey')
    const Authorization = "bearer " + localStorage.getItem("token");
    fetch(`${API_URL}rest/V1/rider/isUserActive`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept, Authorization },
      body: JSON.stringify({
        data: {
            username: username,
            secureKey: secureKey
          },
      }),
    })
      .then(function (response) {
        if (!response.ok) {
          notify.show("Network Failure", "error");
        }
        return response.json();
      })
      .then(function (result) {
        if (result[0] && result[0].status=== "success") {
            console.log("SUCCESSS::::::::",result)
            } else {
             console.log("FAILURE RESULT::::::::::::",result)
             localStorage.clear();
             sessionStorage.clear();
            // this.props.loginAction(true);
            // this.setState({ mark: "Mark In", action: 1 });
            window.location.href="/"
              // component.setState({ isloading: false ,modalChange: false});
              // notify.show(result[0].message, "success");
            }
            // component.setState({ isloading: false });
          });
  };


// WEBPACK FOOTER //
// ./src/utility/api/isUserActive.js